import Save16 from '@carbon/icons-react/es/save/16';
import moment from 'moment';
import React, { FC, useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { CostRate } from 'api/cost-rates';
import { Button } from 'components/atoms/button';
import { RelativeTime } from 'components/atoms/relative-time';
import { Caption01 } from 'components/styles';
import { PermissionsContext } from 'contexts/permissions';
import { fullName } from 'utils/full-name';
import { CostRateDrawerExtras } from '..';

const FooterWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;

  button {
    margin-left: var(--spacing-05);
  }
`;

const StyledCreationMeta = styled.div`
  ${Caption01};
  display: flex;
  align-items: center;
  height: var(--height-lg);
  flex: 1;
`;

interface Props extends Pick<CostRateDrawerExtras, 'userLookup'> {
  costRate?: CostRate;
  isLoading: boolean;
  isSubmitDisabled: boolean;
  onSave: () => void;
  onClose: () => void;
}

export const CostRateDrawerFooter: FC<Props> = ({
  costRate,
  userLookup,
  isLoading,
  isSubmitDisabled,
  onSave,
  onClose,
}) => {
  const getFooterMeta = () => {
    if (costRate == null) {
      return <></>;
    }
    const { createdAt, createdBy } = costRate;
    const creator = createdBy != null ? userLookup[createdBy] : undefined;

    return (
      createdAt &&
      creator && (
        <StyledCreationMeta>
          <FormattedMessage
            id="settings.cost_rates.drawer.footer.meta"
            values={{
              user: fullName(creator),
              time: <RelativeTime time={moment(createdAt)} />,
            }}
          />
        </StyledCreationMeta>
      )
    );
  };

  const { canWrite } = useContext(PermissionsContext);

  return (
    <FooterWrapper>
      <>
        {getFooterMeta()}
        {canWrite && (
          <>
            <Button onClick={onClose}>
              <FormattedMessage id="cancel" />
            </Button>
            <Button
              disabled={isLoading || isSubmitDisabled}
              icon={<Save16 />}
              iconPlacement="right"
              loading={isLoading}
              type="primary"
              onClick={onSave}
            >
              <FormattedMessage id="save" />
            </Button>
          </>
        )}
      </>
    </FooterWrapper>
  );
};
